import { observer } from 'mobx-react-lite';
import { useState, useEffect } from 'react';
import { request } from '@src/common';
import { SVGPureIcon } from '@/ui';
import globalStore from '@/store/global';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Image } from 'antd/es';
import { HelpOther } from '@/common/helper';
import { Spin } from 'antd';
import { Switch, Input, Divider, Card } from 'antd';
import '../index.scss';
import store from '../store'
import homeStore from '@/pages/home/store';
import apiRobot from '@/common/apiRobot';

const Form = observer(() => {

  const [isFocus, setIsFocus] = useState(false);
  const [secretKey, setSecretKey] = useState('');
  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [modelInfo, setModelInfo] = useState({
    key: {},
    websites: {},
    models: []
  });

  const checkSecret = async () => {
    if (secretKey.length <= 0) {
      HelpOther.toast('密钥不能为空', 'info');
      return
    }
    setLoading(true);
    await apiRobot.checkAPIKey(secretKey, modelInfo?.models[0]?.name, null,  modelInfo?.models[0]?.protocol)
      .then(async () => {
        setLoading(false);
        setDisabled(false)
        HelpOther.toast('连接成功', 'success');
        // 将密钥保存到本地列表里
        const newModelInfo = {
          key: {
            api_key: secretKey
          },
          enable: true,
          firm_id: modelInfo?.id,
          models: modelInfo?.models?.map(item => {
            return {
              ...item,
              enable: true,
              update_time: Date.now(),
            }
          })
        }
        // 校验成功后修改状态
        const success = await updateModelState(newModelInfo);
        if (success) {
          const newModel = {
            ...modelInfo,
            key: {
              api_key: secretKey
            },
            enable: true,
            models: modelInfo?.models.map(item => {
              return {
                ...item,
                enable: true,
                update_time: Date.now(),
              }
            })
          }
          setModelInfo(newModel);
          store.setModelFirmList(newModel);
        }
      }).catch(() => {
        setLoading(false);
        HelpOther.toast('连接失败', 'error');
      })
  }
  // 由于列表更新状态需要时间，所以接口成功后先在本地更新状态
  const updateModelState = async (params) => {
    try {
      await request.post('/user/robot/add', params, {
        dataIsJson: true,
      });
      homeStore.setDirty();
      return true;
    } catch (error) {
      HelpOther.toast('更新失败', 'error');
      return false;
    }
  }
  // 服务总开关
  const onChangeFirmSwitch = async (enable) => {
    const params = {
      key: {
        api_key: modelInfo?.key?.api_key
      },
      enable: enable,
      firm_id: modelInfo?.id,
      models: modelInfo?.models?.map(item => {
        return {
          ...item,
          enable: enable,
          update_time: Date.now(),
        }
      })
    }
    const success = await updateModelState(params);
    if (success) {
      const newModelInfo = {
        ...modelInfo,
        enable: enable,
        models: modelInfo?.models?.map(item => {
          return {
            ...item,
            enable: !modelInfo?.enable,
          }
        })
      }
      setModelInfo(newModelInfo);
      store.setModelFirmList(newModelInfo);
    }
  }
  // 单个模型开关
  const onChangeModelSwitch = async ({ id, enable }) => {
    const params = {
      key: {
        api_key: modelInfo?.key?.api_key
      },
      enable: modelInfo?.enable,
      firm_id: modelInfo?.id,
      models: [{
        id,
        enable: !enable,
        update_time: Date.now(),
      }]
    }
    const success = await updateModelState(params);
    if (success) {
      const newModelInfo = {
        ...modelInfo,
        models: modelInfo?.models?.map(item => {
          if (item.id === id) {
            item.enable = !item.enable
          }
          return item
        })
      }
      setModelInfo(newModelInfo);
      store.setModelFirmList(newModelInfo);
    }
  }

  useEffect(() => {
    // 有apikey表示已经检测过
    setDisabled(!store.activeModel?.key?.api_key);
    setModelInfo(store.activeModel);
    // 防止开关时密钥被覆盖
    if (store.activeModel?.id !== modelInfo?.id) {
      setSecretKey(store.activeModel?.key?.api_key);
    }
  }, [store.activeModel]);

  return (
    <Spin spinning={loading}>
      <div className='w-586px h-73vh flex flex-col pl-20px pr-20px nw-scrollbar overflow-y-auto '>
        <InfiniteScroll
          dataLength={store.modeList?.length}
          loader={null}>
          <div className="my-14px">
            <div >
              <div className="flex items-center justify-between">
                <span className="flex text-16px items-center font-bold">
                  {modelInfo?.name}
                  <div className='hover:bg-[rgba(0,0,0,0.03)] h-28px w-28px ml-2px flex items-center justify-center rounded-8px cursor-pointer'>
                    <a
                      className="hover:underline whitespace-nowrap"
                      style={{ color: 'inherit' }}
                      target="_blank"
                      href={modelInfo?.websites?.official}
                    >
                      <SVGPureIcon className="w-16px h-16px" name='link-icon'></SVGPureIcon>
                    </a>
                  </div>
                </span>
                <Switch onClick={onChangeFirmSwitch} disabled={disabled} checked={modelInfo?.enable} className={[globalStore.isDark ? 'dark-switch' : 'light-switch']} />
              </div>
            </div>
            <Divider className={[globalStore.isDark ? 'dark-divider' : '']} />
            {/* API密钥部分 */}
            <div className="mb-32px">
              <label className="block text-14px mb-16px font-bold">API密钥</label>
              <div className="relative">
                <div className={[
                  'flex items-center h-40px border-1px border-solid border-[rgba(0,0,0,0.1)] rounded-12px',
                  'hover:border-[#006AFF]',
                  isFocus ? 'border-[#006AFF]' : 'border-[rgba(0,0,0,0.1)]',
                  globalStore.isDark ? 'bg-[#45454E]' : ''
                ]}>
                  <Input.Password
                    placeholder="多个密钥使用逗号分隔"
                    className="w-full pr-10px custom-input"
                    onInput={(event) => setSecretKey(event.target.value)}
                    onFocus={() => setIsFocus(true)}
                    onBlur={() => setIsFocus(false)}
                    value={secretKey}
                    style={{
                      border: 'none',
                      backgroundColor: 'transparent'
                    }}
                  />
                  <div
                    className={[
                      'border-l flex justify-center h-14px text-14px w-60px cursor-pointer',
                      globalStore.isDark ? 'border-[rgba(255,255,255,0.06)]' : 'border-[rgba(0,0,0,0.06)]'
                    ]}
                    onClick={checkSecret}
                  >
                    检测
                  </div>
                </div>
                <div className="flex mt-10px justify-between">
                  <div className="text-12px underline cursor-pointer">
                    <a
                      className="hover:underline whitespace-nowrap"
                      style={{ color: 'inherit' }}
                      target="_blank"
                      href={modelInfo?.websites?.app_key_url}
                    >
                      点击这里获取密钥
                    </a>
                  </div>
                </div>
              </div>
            </div>
            {/* 模型部分 */}
            <div>
              <label className="block text-14px mb-16px font-bold">模型</label>
              <div className='mb-12px text-14px'>
                <Card
                  title={modelInfo?.name}
                  size="small"
                  className={[globalStore.isDark ? 'dark-card' : '']}
                  style={{
                    border: '1px solid rgba(0,0,0,0.1)',
                    backgroundColor: globalStore.isDark ? '#45454E' : '',
                  }}
                >
                  <div className='flex flex-col'>
                    {
                      (modelInfo?.models || []).map((item, index) => {
                        return (
                          <div className='flex h-48px justify-between items-center' key={index}>
                            <div className='flex gap-8px'>
                              <Image
                                preview={false}
                                src={item.icon}
                                fallback={`https://p0.ssl.qhimg.com/t01fa56fdc3fe79f15f.png`} // 404
                                className="!w-24px !h-24px !object-cover !rounded-8px"
                                rootClassName="!w-24px !h24px !object-cover !rounded-8px"
                              />
                              {item?.title}
                            </div>
                            <div className='flex gap-32px'>
                              {/* <Switch disabled={!modelInfo?.enable} onClick={() => onChangeModelSwitch(item)} checked={item.enable} className={[globalStore.isDark ? 'dark-switch' : 'light-switch']} /> */}
                            </div>
                          </div>
                        )
                      })
                    }
                  </div>
                </Card>
              </div>
              <p className="text-12px">
                查看&nbsp;
                <span className='underline cursor-pointer'>
                  <a
                    className="hover:underline whitespace-nowrap"
                    style={{ color: 'inherit' }}
                    target="_blank"
                    href={modelInfo?.websites?.docs}
                  >
                    {modelInfo?.name}
                  </a>
                </span>&nbsp;
                文档和&nbsp;
                <span className='underline cursor-pointer'>
                  <a
                    className="hover:underline whitespace-nowrap"
                    style={{ color: 'inherit' }}
                    target="_blank"
                    href={modelInfo?.websites?.models}
                  >
                    模型
                  </a>
                </span>&nbsp;
                获取更多详情
              </p>
            </div>
          </div>
        </InfiniteScroll>
      </div>
    </Spin>
  );
});
export default Form;